import { webShopSlice } from "./webShopSlice";
import * as actions from "./webShopActions";
import * as selectors from "./webShopSelectors";

export { actions };
export { selectors };
export default webShopSlice.reducer;